<template>
<div id="home" class="home" v-if="brandList !== null">
  <Header />
  <div class="home__main">
    <video class="home__main__video" webkit-playsinline playsinline autoplay loop muted poster="@/assets/images/home/home-main-poster.jpg">
      <source src="@/assets/video/mainvisual.webm" type="video/webm">
      <source src="@/assets/video/mainvisual.mp4" type="video/mp4">
      <p>Not Movie Support...</p>
    </video>
    <div class="home__main__txt"><img src="@/assets/images/home/home-main-txt.png" alt="My Custom Bag Studio"></div>
  </div>
  <div class="home__how">
    <div class="home__how__ct">
      <h2 class="home__how__ct__ttl">WHAT’S CUSTOM ITEM?</h2>
      <div class="home__how__ct__wrap">
        <router-link to="/howto" class="home__how__ct__wrap__btn">How to Use</router-link>
      </div>
    </div>
    <div class="home__how__img">
      <img src="@/assets/images/home/home-howto.png" width="450" height="200" alt="Howto">
    </div>
  </div>
  <div class="home__select">
    <h2 class="home__select__ttl">SELECT BRAND</h2>
    <p class="home__select__txt">対象ブランドを選択してください</p>
  </div>
  <div class="home__brand">
    <div class="home__brand__ct">
      <template v-for="brand in brandList">
        <router-link
          :key="brand.id"
          :to="{ name: 'item-type', params: { brandID: brand.id } }"
          class="home__brand__ct__item">
          <img :src="brand.mainImage" :alt="brand.name" />
        </router-link>
      </template>
    </div>
  </div>
  <FooterNavi />
  <Footer />
</div>
</template>

<script>
import Header from '@/components/Header'
import FooterNavi from '@/components/FooterNavi'
import Footer from '@/components/Footer'
import customMgr from '@/modules/CustomManager.js'

export default {
  components: {
    Header,
    FooterNavi,
    Footer
  },
  beforeRouteEnter (to, from, next) {
    customMgr.getAllBrands('web').then((brandList) => {
      next(vm => vm.setBrandList(brandList))
    })
  },
  data () {
    return {
      brandList: null
    }
  },
  methods: {
    setBrandList (brandList) {
      this.brandList = brandList
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  &__main {
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    background: #D9747F;
    &__video {
      max-width: 100%;
    }
    &__txt {
      position: absolute;
      left: 15px;
      width: 38vw;
      max-width: 300px;
      top: 20px;
    }

  }
  &__how {
    &__ct {
    padding: 40px 0;
      &__ttl {
        font-size: 18px;
        font-weight: bold;
        text-align: center;
      }
      &__wrap {
        width: 150px;
        margin: 20px auto 0;
        &__btn {
          display: block;
          width: 100%;
          text-align: center;
          padding: 8px 0;
          border: 1px solid $base-black;
          font-size: 13px;
        }
      }
    }
    &__img {
      background: #FFE5E8;
      padding: 20px 30px;
      text-align: center;
      img {
        width: inherit;
        max-width: 80%;
        position: relative;
        right: -5px;
      }
    }
  }
  &__select {
    padding: 50px 0 30px;
    &__ttl {
      font-size: 18px;
      font-weight: bold;
      text-align: center;
    }
    &__txt {
      font-size: 12px;
      text-align: center;
      margin-top: 10px;
    }
  }
  &__brand {
    padding: 15px;
    background-color: #FDF2F2;
    &__ct {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      &__item {
        width: calc(50% - 5px);
        height: 100px;
        background-color: $base-white;
        padding: 25px;
        &:nth-child(n + 3) {
          margin-top: 10px;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue